<template>
  <div class="bottom-label__list">
    <zcy-comp-label v-for="(item, index) in labels" :key="index" v-bind="item"></zcy-comp-label>
  </div>
</template>
<script>
import CompLableItem from './comp-label-item';
export default {
  components: {
    'zcy-comp-label': CompLableItem
  },
  data () {
    return {
      labels: [
        { icon: 'icon-zhengpinbaozhang', text: '正品保障' },
        { icon: 'icon-jiageyouhui', text: '价格优惠' },
        { icon: 'icon-shuangxiangxinyong', text: '双向信用' },
        { icon: 'icon-shouhouwuyou', text: '售后无忧' }
      ]
    };
  }
};
</script>
<style lang="less">
@import '../../assets/css/common.less';
.bottom-label__list {
  display:flex;
  justify-content: space-around;
  width: @width-full;
}
</style>



// WEBPACK FOOTER //
// src/components/bottom/comp-labels.vue